export const { MODE, VITE_BUG_SNAG_API_KEY, VITE_YANDEX_METRIKA_ID } = import.meta.env;

export const BUG_SNAG_ENABLED = Boolean(VITE_BUG_SNAG_API_KEY);

export const YANDEX_METRIKA_ID = Number(VITE_YANDEX_METRIKA_ID);
export const YANDEX_METRIKA_ENABLED = Boolean(VITE_YANDEX_METRIKA_ID);

export const IS_LOCAL = MODE === 'localhost';
export const IS_DEV = MODE === 'development';
export const IS_PROD = MODE === 'production';

export const GAME_HOST = 'cashier-admin.betskilla.com';
export const API_URL = IS_LOCAL ? `https://${GAME_HOST}/api` : '/api';
export const SOCKET_URL = IS_LOCAL ? `wss://${GAME_HOST}/` : `/`;
